<template>
  <main id="main" class="login">
    <SfTile large>
      <template #title>
        <h1 class="account-heading login__heading">
          {{ $t('SHOP.AUTH.HEADER.SIGN_IN') }}
        </h1>
      </template>
      <template #default>
        <AccountSignInForm />
      </template>
    </SfTile>
    <SfTile class="sign-up" large>
      <template #title>
        <h2 class="account-heading">
          {{ $t('SHOP.AUTH.HEADER.SIGN_UP') }}
        </h2>
      </template>
      <template #default>
        <AccountSignUpAdvantages />
        <SfButton :href="$route('web.account.register.create')">
          {{ $t('SHOP.AUTH.ACTION.SIGN_UP') }}
        </SfButton>
      </template>
    </SfTile>
  </main>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .login {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: flex-start;
    gap: 4rem;
    max-width: 1200px;
    margin: 100px auto;
  }

  @include media.query(lg) {
    .login {
      grid-template-columns: 1fr;
      gap: 1rem;
      margin: 1rem 0 2rem;


      .tile__content {
        padding: 1.25rem 0.625rem;

        .tile__header {
          justify-content: center;
        }
      }
    }
  }
</style>
